<template>
  <div
    class="header"
    :class="{ header_show: headerShow, shadow: headerShadowActive }"
  >
    <div class="header_container">
      <div class="header_content">
        <div class="logo">
          <router-link to="/">
            <!-- <img class="user-drag-none" :src="logo_img[0].path" alt="logo" v-if="headerLogoShow === true" />
            <img class="user-drag-none" :src="logo_img[1].path" alt="logo" v-else /> -->
          </router-link>
          <router-link to="/cbg">
            <img
              v-show="pathname == '/cbg'"
              class="user-drag-none"
              style="height: 50px !important; position: absolute; top: 0px"
              src="https://cbg-yjwujian.res.netease.com/mvvm/rc5bb471e17a72efca24b3d29c/dist/cbg-logo-2x-3890.png"
              alt="logo"
            />
          </router-link>
        </div>
        <div class="menu-wrapper">
          <div class="menu-item" v-for="(item, index) in navList" :key="index">
            <h2 class="menu-item-link">
              <router-link v-if="pathname !== '/cbg'" :to="item.path"
                ><span :class="{ a_text_dark: navDarkActive }">{{
                  item.title
                }}</span>
              </router-link>
              <router-link v-else :to="item.path"
                ><span :class="{ a_text_dark: false }">{{ item.title }}</span>
              </router-link>
              <!-- <router-link :to="item.path"><span :class="{ a_text_dark: false }">{{ item.title }}</span>
              </router-link> -->
            </h2>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
import { mapState } from "vuex";
// import { getToken } from '@/utils/auth'
// import { eventIsLogin } from '@/main';
export default {
  name: "Header",
  data() {
    return {
      pathname: null, //路由名字
      navList: [
        {
          title: "首页",
          path: "/?pid=" + this.$route.query.pid,
        },
        // {
        //   title: '藏宝阁',
        //   path: '/cbg'
        // },
        // {
        //   title: '活动大厅',
        //   path: '/news?pid=' + this.$route.query.pid
        // },
        // {
        //   title: "活动 - 新闻",
        //   path: "/news?pid=" + this.$route.query.pid,
        // },
        // {
        //   title: "自助转区",
        //   path: "/user-center?tabSelect=游戏设置&pid=" + this.$route.query.pid,
        // },
        // {
        //   title: "自助充值",
        //   path: "/user-center?tabSelect=游戏充值&pid=" + this.$route.query.pid,
        // },
        // {
        //   title: "用户中心",
        //   path: "/user-center?pid=" + this.$route.query.pid,
        // },
        //   {
        //     title: '产品与服务',
        //     path: '/product'
        //  },

        // {
        //   title: '客户服务',
        //   path: 'http://kkk.pppp.sf123.cloud:801/kf.html'
        // },
        // {
        //   title: '登录',
        //   path: '/login?pid=' + this.$route.query.pid
        // }
      ],
      logo_img: [
        {
          path: require("../../assets/logo_1.png"),
        },
        {
          path: require("../../assets/logo_1.png"),
        },
      ],
    };
  },
  computed: mapState([
    "headerShadowActive",
    "headerShow",
    "headerLogoShow",
    "navDarkActive",
  ]),
  mounted() {
    this.pathname = window.location.pathname;
    //eventIsLogin.$on('userIsLogin', this.loginStatus());
    // eventLoginOut.$on('userLoggedOut', () => {
    //   let nav = this.navList
    //   this.navList[nav.length - 1].title = '登录'
    // });
  },
  beforeDestroy() {
    // eventIsLogin.$off('userIsLogin', this.loginStatus());
    // eventLoginOut.$off('userLoggedOut', () => {
    //   let nav = this.navList
    //   this.navList[nav.length - 1].title = '登录'
    // });
  },
  methods: {
    // loginStatus() {
    //   const nikename = sessionStorage.getItem('nikename')
    //   const hasToken = getToken()
    //   let nav = this.navList
    //   if (hasToken) {
    //     this.navList[nav.length - 1].title = ''
    //   } else {
    //     this.navList[nav.length - 1].title = '登录'
    //   }
    // }
  },
};
</script>
  
<style lang = "less" scoped>
@nav_active_color: #e52e2e;

h2 {
  margin: 0;
}

.header_show {
  transform: translateY(-62px);
}

.a_text_dark {
  color: rgba(0, 0, 0, 0.8);
}

.header {
  width: 100%;
  height: 60px;
  background-color: rgba(255, 255, 255, 0);
  //backdrop-filter: blur(0);
  box-shadow: none;

  position: fixed;
  z-index: 999;
  transition: transform 0.2s ease;

  //color: rgba(255, 255, 255, 1) !important;
  //transition: all 0.3s ease;
  .header_container {
    height: 100%;
  }
}

.shadow {
  background-color: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(8px);
  box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.1);
}

.header_content {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  height: 100%;
  align-items: center;
  padding: 0 96px;
  margin: 0 auto;

  .logo {
    flex: 0 0 auto;

    img {
      height: 70px;
    }
  }
}

.menu-wrapper {
  display: flex;
  flex-direction: row;
  list-style: none;
  -ms-flex-align: center;
  align-items: center;
  padding: 0;
  margin: 0 0 0 20px;
  position: relative;

  .menu-item {
    flex-shrink: 0;
  }

  .menu-item:last-child:before {
    content: "";
    display: block;
    height: 12px;
    border-right: 2px solid #bbbfc4;
    //border-right: 1px solid #fff;
    position: absolute;
    bottom: 24px;
    right: 75px;
  }

  > .menu-item + .menu-item {
    margin-left: 40px;
  }

  .menu-item-link {
    //color: #646a73;
    font-weight: 400;
    font-size: 14px;
    line-height: 60px;
    cursor: pointer;
    position: relative;

    a {
      display: inline-block;
      color:#fff;
      font-weight: 600;
      transition: color 0.3s;
      font-size: 24px;

      :hover {
        color: @nav_active_color;
      }
    }

    .router-link-exact-active {
      color: @nav_active_color;
      font-weight: bold;

      span:after {
        content: "";
        display: block;
        height: 2px;
        position: absolute;
        width: 26px;
        left: calc(50% - 13px);
        bottom: 14px;
        background-color: @nav_active_color;
      }
    }
  }
}

.nav_text_white {
  color: rgba(255, 255, 255, 1);
}

.nav_text_dark {
  color: rgba(0, 0, 0, 0.8);
}

@media only screen and (max-width: 991px) {
  .header_content {
    padding: 0 32px;
  }
}
</style>
  